import { map, filter, find } from 'lodash'

export const error = state => state.error
export const isLoading = state => state.isLoading
export const items = state => state.items
export const view = state => state.view
export const violations = state => state.violations

export const getCategories = state => {
  return map(state.categories, (category) => {
    return { text: category.name, value: category['id'] }
  })
}

export const getTerritories = state => {
  return map(state.territories, (territory) => {
    return { text: territory.name, value: territory['slug'] }
  })
}

export const getGames = state => {
  return filter(state.games, (game) => {
    const gameAlreadyOrdered = find(state.items, (item) => item.id === game.id)
    if (!gameAlreadyOrdered) {
      return game
    }
  })
}

export const isLoadingGames = state => state.isLoadingGames
